(ns motorsaif.data-utils
  (:require
   [clojure.walk :as walk]))

(defn ensure-vec [data]
  (if (vector? data)
    data
    [data]))

(defn assoc-if-val [m k v]
  (if v
    (assoc-in m (ensure-vec k) v)
    m))

(defn update-if-exists [m k f & args]
  (if (get-in m (ensure-vec k))
    (apply update-in m (ensure-vec k) f args)
    m))

(defn present?
  "Return true if value is not empty or nil, works on non colls."
  [v]
  (if (coll? v)
    (and
     (coll? v)
     (seq v))
    (not (nil? v))))

(defn remove-empty-vals
  "Remove all empty and nil values from a map"
  [m]
  (into {}
        (map (fn [[k v]]
               (let [v (if (map? v)
                         (remove-empty-vals v)
                         v)]
                 (if (present? v)
                   [k v]
                   nil)))
             m)))

(defn vec-insert
  "insert elem in coll"
  [coll pos itm]
  (let [coll (vec coll)]
    (vec (concat (subvec coll 0 pos) [itm] (subvec coll pos)))))
;; (vec-insert (range 20) 3 100)

(defn vec-remove
  "remove elem in coll"
  [coll pos]
  (let [coll (vec coll)]
    (vec (concat (subvec coll 0 pos) (subvec coll (inc pos))))))

#?(:cljs
   (defn parse-int
     "If value is not NaN parses int, if not returns val"
     [v]
     (let [parsed (js/parseInt v)]
       (if (js/isNaN parsed)
         v parsed))))

(defn submap?
  "Returns true if map1 is submap of map2. I.e. contains same keys with same
  values but could also contain other keys.
  Also checks that both values are maps, to avoid exceptions if they aren't."
  [map1 map2]
  (and (map? map1)
       (map? map2)
       (= (select-keys map1 (keys map2)) map2)))

(defn wrap-results
  "Hoists :db/ident from being nested
  Note: SLOW
  "
  [data]
  (walk/postwalk
   (fn [itm]
     (if (:db/ident itm)
       (:db/ident itm)
       itm))
   data))


(defn remove-empty-pairs [m]
  ;; remove key/val pairs where value is empty
  (reduce
   (fn [acc [k v]]
     (if (empty? (str v)) ;; cast to string because some vals will be saved as raw data
       acc
       (assoc acc k v)))
   {}
   m))

(defn deep-remove-empty-vals [data]
  (walk/postwalk
   (fn [i]
     (if (map? i)
       (remove-empty-pairs i) i))
   data))

(defn mapval-idx [coll k val]
  (first
   (keep-indexed
    (fn [idx m]
      (if (= (get m k) val)
        idx
        nil))
    coll)))

(defn deep-merge
  "Lazy paste from https://stackoverflow.com/questions/17327733/merge-two-complex-data-structures"
  [a b]
  (merge-with (fn [x y]
                (cond
                  (seq (:raw y)) y ; prevent hiccup from being concatenated.
                  (map? y) (deep-merge x y)
                  (vector? y) (concat x y)
                  :else y))
              a b))

(defn distinct-by
  [k coll]
  (first (get (group-by k coll) k)))

(defn tuples->maps
  "Given a vector of keys and a sequence of tuples, returns a vector of maps.
   Example: (tuples->maps [:message :audit-user-id] [[m1 u1] [m2 u2]])
   => [{:message m1 :audit-user-id u1} {:message m2 :audit-user-id u2}]"
  [keys tuples]
  (mapv #(zipmap keys %) tuples))
